import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, withKeys as _withKeys, toHandlers as _toHandlers, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "cms-editor" };
const _hoisted_2 = {
    key: 0,
    class: "sideaction",
    slot: "header"
};
const _hoisted_3 = ["disabled"];
const _hoisted_4 = ["disabled"];
const _hoisted_5 = {
    class: "component",
    ref: "component"
};
const _hoisted_6 = {
    key: 0,
    class: "blox-buttons"
};
const _hoisted_7 = ["disabled"];
const _hoisted_8 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
            class: _normalizeClass(["blox-wrapper", { editactive: _ctx.edit }])
        }, [
            (_ctx.body)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("button", {
                        class: "add",
                        disabled: _ctx.disabled,
                        title: "add content-block",
                        onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.disableSort()), ["prevent"])),
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.addNewBlock($event)), ["prevent"]))
                    }, [
                        _createVNode(_component_g_icon, { src: "/assets/icons/plus.svg" })
                    ], 40, _hoisted_3),
                    _createElementVNode("button", {
                        class: "delete",
                        disabled: _ctx.disabled,
                        title: "delete content-block",
                        onMousedown: _cache[2] || (_cache[2] = _withModifiers(($event) => (_ctx.disableSort()), ["prevent"])),
                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (_ctx.deleteBlock($event)), ["prevent"]))
                    }, [
                        _createVNode(_component_g_icon, { src: "/assets/icons/x.svg" })
                    ], 40, _hoisted_4)
                ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", _mergeProps({
                class: "background-helper",
                onKeyup: _cache[6] || (_cache[6] = _withKeys(
                //@ts-ignore
                (...args) => (_ctx.submitBlock && _ctx.submitBlock(...args)), ["enter"]))
            }, _toHandlers({ click: !_ctx.edit ? _ctx.getData : null })), [
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_Transition, { name: "fade-editor" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", null, [
                                _renderSlot(_ctx.$slots, "default")
                            ])
                        ]),
                        _: 3
                    }),
                    (_ctx.edit)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("button", {
                                class: "edit",
                                disabled: _ctx.disabled,
                                onClick: _cache[4] || (_cache[4] = _withModifiers(
                                //@ts-ignore
                                (...args) => (_ctx.saveBlock && _ctx.saveBlock(...args)), ["prevent"]))
                            }, "Save", 8, _hoisted_7),
                            _createElementVNode("button", {
                                class: "cancel",
                                disabled: _ctx.disabled,
                                onClick: _cache[5] || (_cache[5] = _withModifiers(
                                //@ts-ignore
                                (...args) => (_ctx.cancel && _ctx.cancel(...args)), ["prevent"]))
                            }, "Cancel", 8, _hoisted_8)
                        ]))
                        : _createCommentVNode("", true)
                ], 512)
            ], 16)
        ], 2)
    ]));
}
